import { useEffect } from 'react';
import {
  offReceiveUpdateCallStatDetailEvent,
  onReceiveUpdateCallStatDetailEvent,
  useCountCallSessionQuery
} from 'services';
import { CountCallSessionDto } from 'types';

export function useCountCallSession(params: CountCallSessionDto) {
  const { data, error, isLoading, refetch } = useCountCallSessionQuery(params);

  useEffect(() => {
    onReceiveUpdateCallStatDetailEvent((data) => {
      refetch();
    });
    return () => {
      offReceiveUpdateCallStatDetailEvent();
    };
  }, []);

  return {
    data: data?.data,
    error,
    isLoading
  };
}
